export function useUtm() {
  const params = new URLSearchParams(window.location.search);
  const keys = [
    'utm_source', 'utm_medium', 'utm_campaign',
    'utm_id', 'utm_content', 'utm_term',
    'gclid', 'fbclid', 'aff_click_id',
  ];
  return keys.reduce((acc, k) => {
    acc[k] = params.get(k) || '';
    return acc;
  }, {});
}
